import _slicedToArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "grpc/txauth/client/txauth_client.proto" (package "grpc.txauth.client", syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "grpc/txauth/client/txauth_client.proto" (package "grpc.txauth.client", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { AnonymousPerson } from "@finam/tx-proto-grpc-txauth-common/proto/txauth/common/anonymous/anonymous_pb";
import { OAuthSource } from "@finam/tx-proto-grpc-txauth-common/proto/txauth/common/oauth/oauth_pb";
import { OAuthConnection } from "@finam/tx-proto-grpc-txauth-common/proto/txauth/common/oauth/oauth_pb";
import { Duration } from "@finam/tx-proto-lib-google-wellknown/google/protobuf/duration_pb";
import { Timestamp } from "@finam/tx-proto-lib-google-wellknown/google/protobuf/timestamp_pb";
import { TokenScope } from "@finam/tx-proto-grpc-txauth-common/proto/txauth/common/token/token_scope_pb";
import { Device } from "@finam/tx-proto-grpc-txauth-common/proto/txauth/common/device/devices_pb";
/**
 * @generated from protobuf enum grpc.txauth.client.AuthByQRSessionResponse.Status
 */

export var AuthByQRSessionResponse_Status;

(function (AuthByQRSessionResponse_Status) {
  /**
   *
   *  QR-код проверяется на мобильном устройстве.
   *  Необходим повторный вызов.
   *
   * @generated from protobuf enum value: WAITING_FOR_CONFIRMATION = 0;
   */
  AuthByQRSessionResponse_Status[AuthByQRSessionResponse_Status["WAITING_FOR_CONFIRMATION"] = 0] = "WAITING_FOR_CONFIRMATION";
  /**
   *
   *  QR-код проверен. Выдан jwt-токен.
   *  Повторный вызов не имеет смысла.
   *
   * @generated from protobuf enum value: READY = 1;
   */

  AuthByQRSessionResponse_Status[AuthByQRSessionResponse_Status["READY"] = 1] = "READY";
  /**
   *
   *  По этому QR-коду уже получен jwt-токен.
   *  Повторный вызов не имеет смысла.
   *
   * @generated from protobuf enum value: ALREADY_USED = 2;
   */

  AuthByQRSessionResponse_Status[AuthByQRSessionResponse_Status["ALREADY_USED"] = 2] = "ALREADY_USED";
  /**
   *
   *  QR-код не найден.
   *  Повторный вызов не имеет смысла.
   *
   * @generated from protobuf enum value: NOT_FOUND = 3;
   */

  AuthByQRSessionResponse_Status[AuthByQRSessionResponse_Status["NOT_FOUND"] = 3] = "NOT_FOUND";
  /**
   *
   *  QR-код просрочен.
   *  Повторный вызов не имеет смысла.
   *
   * @generated from protobuf enum value: EXPIRED = 4;
   */

  AuthByQRSessionResponse_Status[AuthByQRSessionResponse_Status["EXPIRED"] = 4] = "EXPIRED";
})(AuthByQRSessionResponse_Status || (AuthByQRSessionResponse_Status = {})); // @generated message type with reflection information, may provide speed optimized methods


var DecodeRequest$Type = /*#__PURE__*/function (_MessageType) {
  _inherits(DecodeRequest$Type, _MessageType);

  var _super = _createSuper(DecodeRequest$Type);

  function DecodeRequest$Type() {
    _classCallCheck(this, DecodeRequest$Type);

    return _super.call(this, "grpc.txauth.client.DecodeRequest", [{
      no: 1,
      name: "encoded_message",
      kind: "scalar",
      T: 12
      /*ScalarType.BYTES*/

    }]);
  }

  _createClass(DecodeRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        encodedMessage: new Uint8Array(0)
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag = reader.tag(),
            _reader$tag2 = _slicedToArray(_reader$tag, 2),
            fieldNo = _reader$tag2[0],
            wireType = _reader$tag2[1];

        switch (fieldNo) {
          case
          /* bytes encoded_message */
          1:
            message.encodedMessage = reader.bytes();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* bytes encoded_message = 1; */
      if (message.encodedMessage.length) writer.tag(1, WireType.LengthDelimited).bytes(message.encodedMessage);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return DecodeRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.DecodeRequest
 */


export var DecodeRequest = new DecodeRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var DecodeResponse$Type = /*#__PURE__*/function (_MessageType2) {
  _inherits(DecodeResponse$Type, _MessageType2);

  var _super2 = _createSuper(DecodeResponse$Type);

  function DecodeResponse$Type() {
    _classCallCheck(this, DecodeResponse$Type);

    return _super2.call(this, "grpc.txauth.client.DecodeResponse", [{
      no: 1,
      name: "decoded_message",
      kind: "scalar",
      T: 12
      /*ScalarType.BYTES*/

    }]);
  }

  _createClass(DecodeResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        decodedMessage: new Uint8Array(0)
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag3 = reader.tag(),
            _reader$tag4 = _slicedToArray(_reader$tag3, 2),
            fieldNo = _reader$tag4[0],
            wireType = _reader$tag4[1];

        switch (fieldNo) {
          case
          /* bytes decoded_message */
          1:
            message.decodedMessage = reader.bytes();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* bytes decoded_message = 1; */
      if (message.decodedMessage.length) writer.tag(1, WireType.LengthDelimited).bytes(message.decodedMessage);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return DecodeResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.DecodeResponse
 */


export var DecodeResponse = new DecodeResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var EncodeRequest$Type = /*#__PURE__*/function (_MessageType3) {
  _inherits(EncodeRequest$Type, _MessageType3);

  var _super3 = _createSuper(EncodeRequest$Type);

  function EncodeRequest$Type() {
    _classCallCheck(this, EncodeRequest$Type);

    return _super3.call(this, "grpc.txauth.client.EncodeRequest", [{
      no: 1,
      name: "plain_message",
      kind: "scalar",
      T: 12
      /*ScalarType.BYTES*/

    }]);
  }

  _createClass(EncodeRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        plainMessage: new Uint8Array(0)
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag5 = reader.tag(),
            _reader$tag6 = _slicedToArray(_reader$tag5, 2),
            fieldNo = _reader$tag6[0],
            wireType = _reader$tag6[1];

        switch (fieldNo) {
          case
          /* bytes plain_message */
          1:
            message.plainMessage = reader.bytes();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* bytes plain_message = 1; */
      if (message.plainMessage.length) writer.tag(1, WireType.LengthDelimited).bytes(message.plainMessage);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return EncodeRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.EncodeRequest
 */


export var EncodeRequest = new EncodeRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var EncodeResponse$Type = /*#__PURE__*/function (_MessageType4) {
  _inherits(EncodeResponse$Type, _MessageType4);

  var _super4 = _createSuper(EncodeResponse$Type);

  function EncodeResponse$Type() {
    _classCallCheck(this, EncodeResponse$Type);

    return _super4.call(this, "grpc.txauth.client.EncodeResponse", [{
      no: 1,
      name: "encoded_message",
      kind: "scalar",
      T: 12
      /*ScalarType.BYTES*/

    }]);
  }

  _createClass(EncodeResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        encodedMessage: new Uint8Array(0)
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag7 = reader.tag(),
            _reader$tag8 = _slicedToArray(_reader$tag7, 2),
            fieldNo = _reader$tag8[0],
            wireType = _reader$tag8[1];

        switch (fieldNo) {
          case
          /* bytes encoded_message */
          1:
            message.encodedMessage = reader.bytes();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* bytes encoded_message = 1; */
      if (message.encodedMessage.length) writer.tag(1, WireType.LengthDelimited).bytes(message.encodedMessage);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return EncodeResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.EncodeResponse
 */


export var EncodeResponse = new EncodeResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var GetQRCodeRequest$Type = /*#__PURE__*/function (_MessageType5) {
  _inherits(GetQRCodeRequest$Type, _MessageType5);

  var _super5 = _createSuper(GetQRCodeRequest$Type);

  function GetQRCodeRequest$Type() {
    _classCallCheck(this, GetQRCodeRequest$Type);

    return _super5.call(this, "grpc.txauth.client.GetQRCodeRequest", [{
      no: 1,
      name: "device",
      kind: "message",
      T: function T() {
        return Device;
      }
    }, {
      no: 2,
      name: "size",
      kind: "scalar",
      T: 5
      /*ScalarType.INT32*/

    }, {
      no: 3,
      name: "provider",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 4,
      name: "token_scope",
      kind: "message",
      T: function T() {
        return TokenScope;
      }
    }]);
  }

  _createClass(GetQRCodeRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        size: 0,
        provider: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag9 = reader.tag(),
            _reader$tag10 = _slicedToArray(_reader$tag9, 2),
            fieldNo = _reader$tag10[0],
            wireType = _reader$tag10[1];

        switch (fieldNo) {
          case
          /* proto.txauth.common.device.Device device */
          1:
            message.device = Device.internalBinaryRead(reader, reader.uint32(), options, message.device);
            break;

          case
          /* int32 size */
          2:
            message.size = reader.int32();
            break;

          case
          /* string provider */
          3:
            message.provider = reader.string();
            break;

          case
          /* proto.txauth.common.token.TokenScope token_scope */
          4:
            message.tokenScope = TokenScope.internalBinaryRead(reader, reader.uint32(), options, message.tokenScope);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* proto.txauth.common.device.Device device = 1; */
      if (message.device) Device.internalBinaryWrite(message.device, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
      /* int32 size = 2; */

      if (message.size !== 0) writer.tag(2, WireType.Varint).int32(message.size);
      /* string provider = 3; */

      if (message.provider !== "") writer.tag(3, WireType.LengthDelimited).string(message.provider);
      /* proto.txauth.common.token.TokenScope token_scope = 4; */

      if (message.tokenScope) TokenScope.internalBinaryWrite(message.tokenScope, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return GetQRCodeRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.GetQRCodeRequest
 */


export var GetQRCodeRequest = new GetQRCodeRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var GetQRCodeResponse$Type = /*#__PURE__*/function (_MessageType6) {
  _inherits(GetQRCodeResponse$Type, _MessageType6);

  var _super6 = _createSuper(GetQRCodeResponse$Type);

  function GetQRCodeResponse$Type() {
    _classCallCheck(this, GetQRCodeResponse$Type);

    return _super6.call(this, "grpc.txauth.client.GetQRCodeResponse", [{
      no: 1,
      name: "qr_code_content",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "qr_code",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "created",
      kind: "message",
      T: function T() {
        return Timestamp;
      }
    }, {
      no: 4,
      name: "time_to_live",
      kind: "message",
      T: function T() {
        return Duration;
      }
    }]);
  }

  _createClass(GetQRCodeResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        qrCodeContent: "",
        qrCode: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag11 = reader.tag(),
            _reader$tag12 = _slicedToArray(_reader$tag11, 2),
            fieldNo = _reader$tag12[0],
            wireType = _reader$tag12[1];

        switch (fieldNo) {
          case
          /* string qr_code_content */
          1:
            message.qrCodeContent = reader.string();
            break;

          case
          /* string qr_code */
          2:
            message.qrCode = reader.string();
            break;

          case
          /* google.protobuf.Timestamp created */
          3:
            message.created = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.created);
            break;

          case
          /* google.protobuf.Duration time_to_live */
          4:
            message.timeToLive = Duration.internalBinaryRead(reader, reader.uint32(), options, message.timeToLive);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string qr_code_content = 1; */
      if (message.qrCodeContent !== "") writer.tag(1, WireType.LengthDelimited).string(message.qrCodeContent);
      /* string qr_code = 2; */

      if (message.qrCode !== "") writer.tag(2, WireType.LengthDelimited).string(message.qrCode);
      /* google.protobuf.Timestamp created = 3; */

      if (message.created) Timestamp.internalBinaryWrite(message.created, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
      /* google.protobuf.Duration time_to_live = 4; */

      if (message.timeToLive) Duration.internalBinaryWrite(message.timeToLive, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return GetQRCodeResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.GetQRCodeResponse
 */


export var GetQRCodeResponse = new GetQRCodeResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var AuthByQRSessionRequest$Type = /*#__PURE__*/function (_MessageType7) {
  _inherits(AuthByQRSessionRequest$Type, _MessageType7);

  var _super7 = _createSuper(AuthByQRSessionRequest$Type);

  function AuthByQRSessionRequest$Type() {
    _classCallCheck(this, AuthByQRSessionRequest$Type);

    return _super7.call(this, "grpc.txauth.client.AuthByQRSessionRequest", [{
      no: 1,
      name: "qr_session_id",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(AuthByQRSessionRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        qrSessionId: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag13 = reader.tag(),
            _reader$tag14 = _slicedToArray(_reader$tag13, 2),
            fieldNo = _reader$tag14[0],
            wireType = _reader$tag14[1];

        switch (fieldNo) {
          case
          /* string qr_session_id */
          1:
            message.qrSessionId = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string qr_session_id = 1; */
      if (message.qrSessionId !== "") writer.tag(1, WireType.LengthDelimited).string(message.qrSessionId);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return AuthByQRSessionRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.AuthByQRSessionRequest
 */


export var AuthByQRSessionRequest = new AuthByQRSessionRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var AuthByQRSessionResponse$Type = /*#__PURE__*/function (_MessageType8) {
  _inherits(AuthByQRSessionResponse$Type, _MessageType8);

  var _super8 = _createSuper(AuthByQRSessionResponse$Type);

  function AuthByQRSessionResponse$Type() {
    _classCallCheck(this, AuthByQRSessionResponse$Type);

    return _super8.call(this, "grpc.txauth.client.AuthByQRSessionResponse", [{
      no: 1,
      name: "status",
      kind: "enum",
      T: function T() {
        return ["grpc.txauth.client.AuthByQRSessionResponse.Status", AuthByQRSessionResponse_Status];
      }
    }, {
      no: 2,
      name: "jwt_token",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(AuthByQRSessionResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        status: 0,
        jwtToken: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag15 = reader.tag(),
            _reader$tag16 = _slicedToArray(_reader$tag15, 2),
            fieldNo = _reader$tag16[0],
            wireType = _reader$tag16[1];

        switch (fieldNo) {
          case
          /* grpc.txauth.client.AuthByQRSessionResponse.Status status */
          1:
            message.status = reader.int32();
            break;

          case
          /* string jwt_token */
          2:
            message.jwtToken = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* grpc.txauth.client.AuthByQRSessionResponse.Status status = 1; */
      if (message.status !== 0) writer.tag(1, WireType.Varint).int32(message.status);
      /* string jwt_token = 2; */

      if (message.jwtToken !== "") writer.tag(2, WireType.LengthDelimited).string(message.jwtToken);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return AuthByQRSessionResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.AuthByQRSessionResponse
 */


export var AuthByQRSessionResponse = new AuthByQRSessionResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var GetQRSessionDetailsRequest$Type = /*#__PURE__*/function (_MessageType9) {
  _inherits(GetQRSessionDetailsRequest$Type, _MessageType9);

  var _super9 = _createSuper(GetQRSessionDetailsRequest$Type);

  function GetQRSessionDetailsRequest$Type() {
    _classCallCheck(this, GetQRSessionDetailsRequest$Type);

    return _super9.call(this, "grpc.txauth.client.GetQRSessionDetailsRequest", [{
      no: 1,
      name: "qr_session_id",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(GetQRSessionDetailsRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        qrSessionId: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag17 = reader.tag(),
            _reader$tag18 = _slicedToArray(_reader$tag17, 2),
            fieldNo = _reader$tag18[0],
            wireType = _reader$tag18[1];

        switch (fieldNo) {
          case
          /* string qr_session_id */
          1:
            message.qrSessionId = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string qr_session_id = 1; */
      if (message.qrSessionId !== "") writer.tag(1, WireType.LengthDelimited).string(message.qrSessionId);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return GetQRSessionDetailsRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.GetQRSessionDetailsRequest
 */


export var GetQRSessionDetailsRequest = new GetQRSessionDetailsRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var GetQRSessionDetailsResponse$Type = /*#__PURE__*/function (_MessageType10) {
  _inherits(GetQRSessionDetailsResponse$Type, _MessageType10);

  var _super10 = _createSuper(GetQRSessionDetailsResponse$Type);

  function GetQRSessionDetailsResponse$Type() {
    _classCallCheck(this, GetQRSessionDetailsResponse$Type);

    return _super10.call(this, "grpc.txauth.client.GetQRSessionDetailsResponse", [{
      no: 1,
      name: "device",
      kind: "message",
      T: function T() {
        return Device;
      }
    }, {
      no: 2,
      name: "remote_ip",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "provider",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(GetQRSessionDetailsResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        remoteIp: "",
        provider: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag19 = reader.tag(),
            _reader$tag20 = _slicedToArray(_reader$tag19, 2),
            fieldNo = _reader$tag20[0],
            wireType = _reader$tag20[1];

        switch (fieldNo) {
          case
          /* proto.txauth.common.device.Device device */
          1:
            message.device = Device.internalBinaryRead(reader, reader.uint32(), options, message.device);
            break;

          case
          /* string remote_ip */
          2:
            message.remoteIp = reader.string();
            break;

          case
          /* string provider */
          3:
            message.provider = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* proto.txauth.common.device.Device device = 1; */
      if (message.device) Device.internalBinaryWrite(message.device, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
      /* string remote_ip = 2; */

      if (message.remoteIp !== "") writer.tag(2, WireType.LengthDelimited).string(message.remoteIp);
      /* string provider = 3; */

      if (message.provider !== "") writer.tag(3, WireType.LengthDelimited).string(message.provider);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return GetQRSessionDetailsResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.GetQRSessionDetailsResponse
 */


export var GetQRSessionDetailsResponse = new GetQRSessionDetailsResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var ApproveQRSessionRequest$Type = /*#__PURE__*/function (_MessageType11) {
  _inherits(ApproveQRSessionRequest$Type, _MessageType11);

  var _super11 = _createSuper(ApproveQRSessionRequest$Type);

  function ApproveQRSessionRequest$Type() {
    _classCallCheck(this, ApproveQRSessionRequest$Type);

    return _super11.call(this, "grpc.txauth.client.ApproveQRSessionRequest", [{
      no: 1,
      name: "qr_session_id",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(ApproveQRSessionRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        qrSessionId: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag21 = reader.tag(),
            _reader$tag22 = _slicedToArray(_reader$tag21, 2),
            fieldNo = _reader$tag22[0],
            wireType = _reader$tag22[1];

        switch (fieldNo) {
          case
          /* string qr_session_id */
          1:
            message.qrSessionId = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string qr_session_id = 1; */
      if (message.qrSessionId !== "") writer.tag(1, WireType.LengthDelimited).string(message.qrSessionId);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return ApproveQRSessionRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.ApproveQRSessionRequest
 */


export var ApproveQRSessionRequest = new ApproveQRSessionRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var ApproveQRSessionResponse$Type = /*#__PURE__*/function (_MessageType12) {
  _inherits(ApproveQRSessionResponse$Type, _MessageType12);

  var _super12 = _createSuper(ApproveQRSessionResponse$Type);

  function ApproveQRSessionResponse$Type() {
    _classCallCheck(this, ApproveQRSessionResponse$Type);

    return _super12.call(this, "grpc.txauth.client.ApproveQRSessionResponse", []);
  }

  _createClass(ApproveQRSessionResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {};
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      return target !== null && target !== void 0 ? target : this.create();
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return ApproveQRSessionResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.ApproveQRSessionResponse
 */


export var ApproveQRSessionResponse = new ApproveQRSessionResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var GetOAuthConnectionsRequest$Type = /*#__PURE__*/function (_MessageType13) {
  _inherits(GetOAuthConnectionsRequest$Type, _MessageType13);

  var _super13 = _createSuper(GetOAuthConnectionsRequest$Type);

  function GetOAuthConnectionsRequest$Type() {
    _classCallCheck(this, GetOAuthConnectionsRequest$Type);

    return _super13.call(this, "grpc.txauth.client.GetOAuthConnectionsRequest", []);
  }

  _createClass(GetOAuthConnectionsRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {};
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      return target !== null && target !== void 0 ? target : this.create();
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return GetOAuthConnectionsRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.GetOAuthConnectionsRequest
 */


export var GetOAuthConnectionsRequest = new GetOAuthConnectionsRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var GetOAuthConnectionsResponse$Type = /*#__PURE__*/function (_MessageType14) {
  _inherits(GetOAuthConnectionsResponse$Type, _MessageType14);

  var _super14 = _createSuper(GetOAuthConnectionsResponse$Type);

  function GetOAuthConnectionsResponse$Type() {
    _classCallCheck(this, GetOAuthConnectionsResponse$Type);

    return _super14.call(this, "grpc.txauth.client.GetOAuthConnectionsResponse", [{
      no: 1,
      name: "connection",
      kind: "message",
      repeat: 1
      /*RepeatType.PACKED*/
      ,
      T: function T() {
        return OAuthConnection;
      }
    }]);
  }

  _createClass(GetOAuthConnectionsResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        connection: []
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag23 = reader.tag(),
            _reader$tag24 = _slicedToArray(_reader$tag23, 2),
            fieldNo = _reader$tag24[0],
            wireType = _reader$tag24[1];

        switch (fieldNo) {
          case
          /* repeated proto.txauth.common.oauth.OAuthConnection connection */
          1:
            message.connection.push(OAuthConnection.internalBinaryRead(reader, reader.uint32(), options));
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* repeated proto.txauth.common.oauth.OAuthConnection connection = 1; */
      for (var i = 0; i < message.connection.length; i++) {
        OAuthConnection.internalBinaryWrite(message.connection[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
      }

      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return GetOAuthConnectionsResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.GetOAuthConnectionsResponse
 */


export var GetOAuthConnectionsResponse = new GetOAuthConnectionsResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var OAuthConnectRequest$Type = /*#__PURE__*/function (_MessageType15) {
  _inherits(OAuthConnectRequest$Type, _MessageType15);

  var _super15 = _createSuper(OAuthConnectRequest$Type);

  function OAuthConnectRequest$Type() {
    _classCallCheck(this, OAuthConnectRequest$Type);

    return _super15.call(this, "grpc.txauth.client.OAuthConnectRequest", [{
      no: 1,
      name: "oauth_source",
      kind: "enum",
      T: function T() {
        return ["proto.txauth.common.oauth.OAuthSource", OAuthSource];
      }
    }, {
      no: 3,
      name: "redirect_uri",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(OAuthConnectRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        oauthSource: 0,
        redirectUri: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag25 = reader.tag(),
            _reader$tag26 = _slicedToArray(_reader$tag25, 2),
            fieldNo = _reader$tag26[0],
            wireType = _reader$tag26[1];

        switch (fieldNo) {
          case
          /* proto.txauth.common.oauth.OAuthSource oauth_source */
          1:
            message.oauthSource = reader.int32();
            break;

          case
          /* string redirect_uri */
          3:
            message.redirectUri = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* proto.txauth.common.oauth.OAuthSource oauth_source = 1; */
      if (message.oauthSource !== 0) writer.tag(1, WireType.Varint).int32(message.oauthSource);
      /* string redirect_uri = 3; */

      if (message.redirectUri !== "") writer.tag(3, WireType.LengthDelimited).string(message.redirectUri);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return OAuthConnectRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.OAuthConnectRequest
 */


export var OAuthConnectRequest = new OAuthConnectRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var OAuthConnectResponse$Type = /*#__PURE__*/function (_MessageType16) {
  _inherits(OAuthConnectResponse$Type, _MessageType16);

  var _super16 = _createSuper(OAuthConnectResponse$Type);

  function OAuthConnectResponse$Type() {
    _classCallCheck(this, OAuthConnectResponse$Type);

    return _super16.call(this, "grpc.txauth.client.OAuthConnectResponse", [{
      no: 1,
      name: "uri",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(OAuthConnectResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        uri: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag27 = reader.tag(),
            _reader$tag28 = _slicedToArray(_reader$tag27, 2),
            fieldNo = _reader$tag28[0],
            wireType = _reader$tag28[1];

        switch (fieldNo) {
          case
          /* string uri */
          1:
            message.uri = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string uri = 1; */
      if (message.uri !== "") writer.tag(1, WireType.LengthDelimited).string(message.uri);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return OAuthConnectResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.OAuthConnectResponse
 */


export var OAuthConnectResponse = new OAuthConnectResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var OAuthDisconnectRequest$Type = /*#__PURE__*/function (_MessageType17) {
  _inherits(OAuthDisconnectRequest$Type, _MessageType17);

  var _super17 = _createSuper(OAuthDisconnectRequest$Type);

  function OAuthDisconnectRequest$Type() {
    _classCallCheck(this, OAuthDisconnectRequest$Type);

    return _super17.call(this, "grpc.txauth.client.OAuthDisconnectRequest", [{
      no: 1,
      name: "oauth_source",
      kind: "enum",
      T: function T() {
        return ["proto.txauth.common.oauth.OAuthSource", OAuthSource];
      }
    }]);
  }

  _createClass(OAuthDisconnectRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        oauthSource: 0
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag29 = reader.tag(),
            _reader$tag30 = _slicedToArray(_reader$tag29, 2),
            fieldNo = _reader$tag30[0],
            wireType = _reader$tag30[1];

        switch (fieldNo) {
          case
          /* proto.txauth.common.oauth.OAuthSource oauth_source */
          1:
            message.oauthSource = reader.int32();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* proto.txauth.common.oauth.OAuthSource oauth_source = 1; */
      if (message.oauthSource !== 0) writer.tag(1, WireType.Varint).int32(message.oauthSource);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return OAuthDisconnectRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.OAuthDisconnectRequest
 */


export var OAuthDisconnectRequest = new OAuthDisconnectRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var OAuthDisconnectResponse$Type = /*#__PURE__*/function (_MessageType18) {
  _inherits(OAuthDisconnectResponse$Type, _MessageType18);

  var _super18 = _createSuper(OAuthDisconnectResponse$Type);

  function OAuthDisconnectResponse$Type() {
    _classCallCheck(this, OAuthDisconnectResponse$Type);

    return _super18.call(this, "grpc.txauth.client.OAuthDisconnectResponse", []);
  }

  _createClass(OAuthDisconnectResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {};
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      return target !== null && target !== void 0 ? target : this.create();
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return OAuthDisconnectResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.OAuthDisconnectResponse
 */


export var OAuthDisconnectResponse = new OAuthDisconnectResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var OAuthLoginRequest$Type = /*#__PURE__*/function (_MessageType19) {
  _inherits(OAuthLoginRequest$Type, _MessageType19);

  var _super19 = _createSuper(OAuthLoginRequest$Type);

  function OAuthLoginRequest$Type() {
    _classCallCheck(this, OAuthLoginRequest$Type);

    return _super19.call(this, "grpc.txauth.client.OAuthLoginRequest", [{
      no: 1,
      name: "provider",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "oauth_source",
      kind: "enum",
      T: function T() {
        return ["proto.txauth.common.oauth.OAuthSource", OAuthSource];
      }
    }, {
      no: 3,
      name: "redirect_uri",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 4,
      name: "token_total_expiration",
      kind: "message",
      T: function T() {
        return Duration;
      }
    }]);
  }

  _createClass(OAuthLoginRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        provider: "",
        oauthSource: 0,
        redirectUri: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag31 = reader.tag(),
            _reader$tag32 = _slicedToArray(_reader$tag31, 2),
            fieldNo = _reader$tag32[0],
            wireType = _reader$tag32[1];

        switch (fieldNo) {
          case
          /* string provider */
          1:
            message.provider = reader.string();
            break;

          case
          /* proto.txauth.common.oauth.OAuthSource oauth_source */
          2:
            message.oauthSource = reader.int32();
            break;

          case
          /* string redirect_uri */
          3:
            message.redirectUri = reader.string();
            break;

          case
          /* google.protobuf.Duration token_total_expiration */
          4:
            message.tokenTotalExpiration = Duration.internalBinaryRead(reader, reader.uint32(), options, message.tokenTotalExpiration);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string provider = 1; */
      if (message.provider !== "") writer.tag(1, WireType.LengthDelimited).string(message.provider);
      /* proto.txauth.common.oauth.OAuthSource oauth_source = 2; */

      if (message.oauthSource !== 0) writer.tag(2, WireType.Varint).int32(message.oauthSource);
      /* string redirect_uri = 3; */

      if (message.redirectUri !== "") writer.tag(3, WireType.LengthDelimited).string(message.redirectUri);
      /* google.protobuf.Duration token_total_expiration = 4; */

      if (message.tokenTotalExpiration) Duration.internalBinaryWrite(message.tokenTotalExpiration, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return OAuthLoginRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.OAuthLoginRequest
 */


export var OAuthLoginRequest = new OAuthLoginRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var OAuthLoginResponse$Type = /*#__PURE__*/function (_MessageType20) {
  _inherits(OAuthLoginResponse$Type, _MessageType20);

  var _super20 = _createSuper(OAuthLoginResponse$Type);

  function OAuthLoginResponse$Type() {
    _classCallCheck(this, OAuthLoginResponse$Type);

    return _super20.call(this, "grpc.txauth.client.OAuthLoginResponse", [{
      no: 1,
      name: "uri",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(OAuthLoginResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        uri: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag33 = reader.tag(),
            _reader$tag34 = _slicedToArray(_reader$tag33, 2),
            fieldNo = _reader$tag34[0],
            wireType = _reader$tag34[1];

        switch (fieldNo) {
          case
          /* string uri */
          1:
            message.uri = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string uri = 1; */
      if (message.uri !== "") writer.tag(1, WireType.LengthDelimited).string(message.uri);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return OAuthLoginResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.OAuthLoginResponse
 */


export var OAuthLoginResponse = new OAuthLoginResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var SubscribeRenewRequest$Type = /*#__PURE__*/function (_MessageType21) {
  _inherits(SubscribeRenewRequest$Type, _MessageType21);

  var _super21 = _createSuper(SubscribeRenewRequest$Type);

  function SubscribeRenewRequest$Type() {
    _classCallCheck(this, SubscribeRenewRequest$Type);

    return _super21.call(this, "grpc.txauth.client.SubscribeRenewRequest", [{
      no: 1,
      name: "token",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "device",
      kind: "message",
      T: function T() {
        return Device;
      }
    }, {
      no: 3,
      name: "code",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 4,
      name: "force",
      kind: "scalar",
      T: 8
      /*ScalarType.BOOL*/

    }, {
      no: 5,
      name: "token_scope",
      kind: "message",
      T: function T() {
        return TokenScope;
      }
    }]);
  }

  _createClass(SubscribeRenewRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        token: "",
        code: "",
        force: false
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag35 = reader.tag(),
            _reader$tag36 = _slicedToArray(_reader$tag35, 2),
            fieldNo = _reader$tag36[0],
            wireType = _reader$tag36[1];

        switch (fieldNo) {
          case
          /* string token */
          1:
            message.token = reader.string();
            break;

          case
          /* proto.txauth.common.device.Device device */
          2:
            message.device = Device.internalBinaryRead(reader, reader.uint32(), options, message.device);
            break;

          case
          /* string code */
          3:
            message.code = reader.string();
            break;

          case
          /* bool force */
          4:
            message.force = reader.bool();
            break;

          case
          /* proto.txauth.common.token.TokenScope token_scope */
          5:
            message.tokenScope = TokenScope.internalBinaryRead(reader, reader.uint32(), options, message.tokenScope);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string token = 1; */
      if (message.token !== "") writer.tag(1, WireType.LengthDelimited).string(message.token);
      /* proto.txauth.common.device.Device device = 2; */

      if (message.device) Device.internalBinaryWrite(message.device, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
      /* string code = 3; */

      if (message.code !== "") writer.tag(3, WireType.LengthDelimited).string(message.code);
      /* bool force = 4; */

      if (message.force !== false) writer.tag(4, WireType.Varint).bool(message.force);
      /* proto.txauth.common.token.TokenScope token_scope = 5; */

      if (message.tokenScope) TokenScope.internalBinaryWrite(message.tokenScope, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return SubscribeRenewRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.SubscribeRenewRequest
 */


export var SubscribeRenewRequest = new SubscribeRenewRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var SubscribeRenewResponse$Type = /*#__PURE__*/function (_MessageType22) {
  _inherits(SubscribeRenewResponse$Type, _MessageType22);

  var _super22 = _createSuper(SubscribeRenewResponse$Type);

  function SubscribeRenewResponse$Type() {
    _classCallCheck(this, SubscribeRenewResponse$Type);

    return _super22.call(this, "grpc.txauth.client.SubscribeRenewResponse", [{
      no: 1,
      name: "token",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(SubscribeRenewResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        token: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag37 = reader.tag(),
            _reader$tag38 = _slicedToArray(_reader$tag37, 2),
            fieldNo = _reader$tag38[0],
            wireType = _reader$tag38[1];

        switch (fieldNo) {
          case
          /* string token */
          1:
            message.token = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string token = 1; */
      if (message.token !== "") writer.tag(1, WireType.LengthDelimited).string(message.token);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return SubscribeRenewResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.SubscribeRenewResponse
 */


export var SubscribeRenewResponse = new SubscribeRenewResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var ComingOutRequest$Type = /*#__PURE__*/function (_MessageType23) {
  _inherits(ComingOutRequest$Type, _MessageType23);

  var _super23 = _createSuper(ComingOutRequest$Type);

  function ComingOutRequest$Type() {
    _classCallCheck(this, ComingOutRequest$Type);

    return _super23.call(this, "grpc.txauth.client.ComingOutRequest", [{
      no: 1,
      name: "person",
      kind: "message",
      T: function T() {
        return AnonymousPerson;
      }
    }]);
  }

  _createClass(ComingOutRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {};
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag39 = reader.tag(),
            _reader$tag40 = _slicedToArray(_reader$tag39, 2),
            fieldNo = _reader$tag40[0],
            wireType = _reader$tag40[1];

        switch (fieldNo) {
          case
          /* proto.txauth.common.anonymous.AnonymousPerson person */
          1:
            message.person = AnonymousPerson.internalBinaryRead(reader, reader.uint32(), options, message.person);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* proto.txauth.common.anonymous.AnonymousPerson person = 1; */
      if (message.person) AnonymousPerson.internalBinaryWrite(message.person, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return ComingOutRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.ComingOutRequest
 */


export var ComingOutRequest = new ComingOutRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var ComingOutResponse$Type = /*#__PURE__*/function (_MessageType24) {
  _inherits(ComingOutResponse$Type, _MessageType24);

  var _super24 = _createSuper(ComingOutResponse$Type);

  function ComingOutResponse$Type() {
    _classCallCheck(this, ComingOutResponse$Type);

    return _super24.call(this, "grpc.txauth.client.ComingOutResponse", [{
      no: 1,
      name: "token",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(ComingOutResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        token: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag41 = reader.tag(),
            _reader$tag42 = _slicedToArray(_reader$tag41, 2),
            fieldNo = _reader$tag42[0],
            wireType = _reader$tag42[1];

        switch (fieldNo) {
          case
          /* string token */
          1:
            message.token = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string token = 1; */
      if (message.token !== "") writer.tag(1, WireType.LengthDelimited).string(message.token);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return ComingOutResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.client.ComingOutResponse
 */


export var ComingOutResponse = new ComingOutResponse$Type();
/**
 * @generated ServiceType for protobuf service grpc.txauth.client.TxAuthClient
 */

export var TxAuthClient = new ServiceType("grpc.txauth.client.TxAuthClient", [{
  name: "SubscribeRenew",
  serverStreaming: true,
  options: {
    "google.api.http": {
      post: "/grpc-json/txauth/v3/subscriberenew",
      body: "*"
    }
  },
  I: SubscribeRenewRequest,
  O: SubscribeRenewResponse
}, {
  name: "OAuthLogin",
  options: {
    "google.api.http": {
      post: "/grpc-json/txauth/v3/oauthlogin",
      body: "*"
    }
  },
  I: OAuthLoginRequest,
  O: OAuthLoginResponse
}, {
  name: "GetOAuthConnections",
  options: {
    "google.api.http": {
      post: "/grpc-json/txauth/v3/getoauthconnections",
      body: "*"
    }
  },
  I: GetOAuthConnectionsRequest,
  O: GetOAuthConnectionsResponse
}, {
  name: "OAuthConnect",
  options: {
    "google.api.http": {
      post: "/grpc-json/txauth/v3/oauthconnect",
      body: "*"
    }
  },
  I: OAuthConnectRequest,
  O: OAuthConnectResponse
}, {
  name: "OAuthDisconnect",
  options: {
    "google.api.http": {
      post: "/grpc-json/txauth/v3/oauthdisconnect",
      body: "*"
    }
  },
  I: OAuthDisconnectRequest,
  O: OAuthDisconnectResponse
}, {
  name: "Encode",
  options: {
    "google.api.http": {
      post: "/grpc-json/txauth/v3/encodemessage",
      body: "*"
    }
  },
  I: EncodeRequest,
  O: EncodeResponse
}, {
  name: "Decode",
  options: {
    "google.api.http": {
      post: "/grpc-json/txauth/v3/decodemessage",
      body: "*"
    }
  },
  I: DecodeRequest,
  O: DecodeResponse
}, {
  name: "GetQRCode",
  options: {
    "google.api.http": {
      post: "/grpc-json/txauth/v3/getqrcode",
      body: "*"
    }
  },
  I: GetQRCodeRequest,
  O: GetQRCodeResponse
}, {
  name: "AuthByQRSession",
  options: {
    "google.api.http": {
      post: "/grpc-json/txauth/v3/authbyqrcode",
      body: "*"
    }
  },
  I: AuthByQRSessionRequest,
  O: AuthByQRSessionResponse
}, {
  name: "GetQRSessionDetails",
  options: {
    "google.api.http": {
      post: "/grpc-json/txauth/v3/getqrsessiondetails",
      body: "*"
    }
  },
  I: GetQRSessionDetailsRequest,
  O: GetQRSessionDetailsResponse
}, {
  name: "ApproveQRSession",
  options: {
    "google.api.http": {
      post: "/grpc-json/txauth/v3/approveqrsession",
      body: "*"
    }
  },
  I: ApproveQRSessionRequest,
  O: ApproveQRSessionResponse
}, {
  name: "ComingOut",
  options: {
    "google.api.http": {
      post: "/grpc-json/txauth/v3/comingout",
      body: "*"
    }
  },
  I: ComingOutRequest,
  O: ComingOutResponse
}]);